import { connect } from 'react-redux';
import { selectLayer, changeColorBy, clearSelection } from '../store/Sierra/actionCreators';
import { LayerTab } from '../components';
import {
  checkboxChange, selectedAll, clearOneSelection,
  cancelSelectedAll, showSelected, hideSelected, changeDisplaySelected, changeShowNameStatus
} from '../store/Sierra/actionCreators';
import '../index.css';


const mapState = (state) => {
  const { SierraReducer: { explorer: { selections } }, LoginReducer: { pageType } } = state;
  const { defaultLeft, defaultTop } = state.PanelStatus;
  return {
    selections,
    defaultLeft,
    defaultTop,
    pageType
  }
}

const mapDispatch = (dispatch) => ({
  selectLayer(checkedList, designID) {
    dispatch(selectLayer(checkedList, designID));
  },
  changeColorBy(value, designID) {
    dispatch(changeColorBy(value, designID))
  },
  checkboxChanged: (canvasObj) => {
    dispatch(checkboxChange(canvasObj))
  },
  clearOneSelection: (arr, designID) => {
    dispatch(clearOneSelection(arr, designID))
  },
  selectedAll: (designID) => {
    dispatch(selectedAll(designID))
  },
  cancelSelectedAll: (designID) => {
    dispatch(cancelSelectedAll(designID))
  },
  showSelected: (designID) => {
    dispatch(showSelected(designID))
  },
  hideSelected: (designID) => {
    dispatch(hideSelected(designID))
  },
  changeDisplaySelected(show, designID) {
    dispatch(changeDisplaySelected(show, designID))
  },
  changeShowNameStatus(status, designID) {
    dispatch(changeShowNameStatus(status, designID))
  },
  clearSelection(designID) {
    dispatch(clearSelection(designID))
  }
})

export default connect(mapState, mapDispatch)(LayerTab);